<template></template>


<script>
export default {
  mounted() {
    localStorage.setItem("token", this.$route.params.token);

    window.axios.defaults.params = { api_token: this.$route.params.token };

    Event.$emit("login", {});

    this.$router.push("/portal");
  },
};
</script>
